export const SET_NAME = 'SET_NAME';
export const SET_BILLING_COUNTRY = 'SET_BILLING_COUNTRY';
export const SET_PROVINCE = 'SET_PROVINCE';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_CITY = 'SET_CITY';
export const SET_ZIP = 'SET_ZIP';
export const SET_SUGGESTED_PRICE = 'SET_SUGGESTED_PRICE';

